import DOMPurify from "isomorphic-dompurify"

export const formatDecimal = (
  amount: number | undefined | null,
  fractionDigits = 1,
) => {
  const formatAmount = amount || 0
  return Number(Number(formatAmount).toFixed(fractionDigits))
}

export const getFileNameFromUrl = (fileUrl: string): string => {
  if (!fileUrl) return ""

  return fileUrl.split("/").pop() ?? ""
}

/**
 * Return only text content from a markup content string.
 */
export function stripHTML(content: string) {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ["#text"],
    KEEP_CONTENT: true,
  })
}
